import { createSlice } from "@reduxjs/toolkit";

const authLoadingSlice = createSlice({
  name: "authLoading",
  initialState: true,
  reducers: {
    setAuthLoading: (state, action) => action.payload,
  },
});

export const { setAuthLoading } = authLoadingSlice.actions;
export default authLoadingSlice.reducer;